<template>
    <div>
        <table class="table" v-if="productList.length!=0" style="table-layout:fixed;">
            <thead>
                <tr>
                    <th style = "text-align: center;width:3%">
						<input v-model="actionSelectionControl" type="checkbox" />
					</th>
					<th class="link" v-on:click="sorting('created_on',$event)" >Created <i class="sort fa " :class="sort.field=='created_on'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"></i></th>
                    <th style="width:155px">ASIN</th>
                    <th style="width:28%" class="link" v-on:click="sorting('product_title',$event)">Title <i class="sort fa " :class="sort.field=='product_title'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"></i></th>
                    <th v-for="(item,index) in default_tag_list">{{item.name}}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in productList" :key="item.asin + '_' + item.product_title + '_' + index" :class="index%2==0?'even':''">
                    <td style = "text-align: center;">
						<input v-model="item.isSelected" @change="addProductToSelected(item)" type="checkbox"  />
					</td>
                    <td style="width:5%">{{ formatDate(item.created_on)}}</td>
                    <td ><a href="javascript:void(0)" @click="navigateToAddEditProduct(item)" style="color: #143A33;" >{{ item.asin }} <span v-if="item.asin_sku_count > 1"> <br/> ({{item.seller_sku}})</span> </a></td>
                    <td >{{ item.product_title }}</td>
                    <td v-for="(tag,index) in default_tag_list" >{{getDataValue(item,tag)}}</td>
                   <td>
                        <div class="row-add-edit" id = "product-list-drop-down">
                            <a href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown" ></a>
                            <div class="dropdown-menu remove-style" aria-labelledby="dropdownMenuButton" style="" id = "product-list-data">
                                <a class="grid-item ico-add-new" href="javascript:void(0)" @click="navigateToAddToCampaign(item)" v-if = "isVendorInList(item)">Add to Campaign</a>
                                <a class="grid-item ico-delete" href="javascript:void(0)" @click="openDeleteConfirmModal(item)">Delete</a>
                                <a v-if ="item.brand_tag || item.category || item.style || item.custom_tag_count>0" class="grid-item ico-delete" href="javascript:void(0)" @click="openDeleteTagModal(item)">Delete Tag</a>
                                <a class="grid-item ico-edit" href="javascript:void(0)" @click="addTag(item)">Add Tag</a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>

        </table>
	    <NoDataAvailable displayMessage="No Data Is Available" v-else></NoDataAvailable>
		<CannotDeletePopUp
			headerMsg = "Delete"
			:deleteMessage = "delMsg"
			@ProvideVal = "ProvideVal"
			/>
        <DeleteSingleProductConfirmModal @deleteSelectedProducts="deleteProduct" :notDeleted = "notDeleted" :delHeaderMsg='updateHeading(projectObj.product_title)'></DeleteSingleProductConfirmModal>
        <RemoveTag
			:product = "selectedProuctForTagToDelete"
			@closeModal = "closeRemoveTagModal"
		/>
		<AddTags2
			  :product = "productTagsAdded"
			  @closeModal = "closeTagModal"
		/>
    </div>
</template>

<script>
import CannotDeletePopUp from '@/components/product/CannotDeletePopUp'
import DeleteSingleProductConfirmModal from '@/components/product/DeleteSingleProductConfirmModal'
import RemoveTag from '@/components/product/RemoveTag'
import NoDataAvailable from '../NoDataAvailable.vue'
import { getDisplayDateFromTimestamp } from '@/utils/constant-helper'
import AddTags2 from '@/components/product/AddTags2'
import moment from "moment";

export default {
    name: 'ProductListGrid',
    data() {
        return {
            projectObj: {},
            notDeleted : false,
            cannotDelete: false,
			selectedProuctForTagToDelete:{},
			delMsg : "Can not Delete as part of Campaign",
			productTagsAdded:{},
            default_tag_list:[
                { name: 'Brand', value: 'brand_product'},
                { name: 'Style', value: 'style_product'},
                { name: 'Category', value: 'category_product'},
                { name: 'Sub-Category', value: 'sub_category_product'},
                { name: 'Product Group', value: 'product_group_product'},
                { name: 'Size', value: 'size_product'},
                { name: 'Flavor', value: 'flavor_product'},
                { name: 'GL', value: 'gl_product'},
                { name: 'Competitor', value: 'competitor_product'},
                { name: 'Color', value: 'color_product'}
            ]
        }
    },
    components: {
        CannotDeletePopUp,
        DeleteSingleProductConfirmModal,
        NoDataAvailable,
		RemoveTag,
		AddTags2
    },
    computed: {
        defaultFilter: {
            get() {
                let tagops = this.$store.state.tagFilterOptions
                return tagops && tagops.length==0 || !tagops
            }
        },
        sort: {
				set(val) {
                    this.$store.commit("setSelectedSortOrder", val);
				},
				get() {
				    return this.$store.state.selectedSortOrder;
				}
          	},
        productList: {
            set(val) {
                this.$store.state.product.productList = val
            },
            get() {
                return this.$store.state.product.productList
            }
        },
        filterTagOptions: {
            set(val) {
                this.$store.state.product.filterTagOptions = val
            },
            get() {
                console.log('FILTER_TAG_OPTIONS',this.$store.state.product.filterTagOptions)
				return this.$store.state.tagFilterOptions
            }
        },
        productAccendingOrder: {
            set(val) {
                this.$store.state.product.productAccendingOrder = val
                this.$store.commit('product/sortProductList')
            },
            get() {
                return this.$store.state.product.productAccendingOrder
            }
        },
        selectedProducts: {
            set(val) {
                this.$store.state.product.selectedProducts = val
            },
            get() {
				if(this.$store.state.product.selectedProducts.length == 0){
					this.resetSelectAllProduct()
				}
				return this.$store.state.product.selectedProducts;
            }
        },
        actionSelectionControl: {
            set(val) {
                this.$store.state.product.actionSelectionControl = val
                if (val) {
                    this.selectAllProduct()
                }
                else {
                    this.resetSelectAllProduct()
                }
            },
            get() {
                return this.$store.state.product.actionSelectionControl
            }
        },
		selectedVendor: {
			set(val) {
				 this.$store.state.selectedVendor = val
			},
			get() {
				 return this.$store.state.selectedVendor;
			}
		},
		grouping: {
			get() {
                return this.$store.state.product.grouping? this.$store.state.product.grouping:'Client'
			}
		}
    },
	watch:{
        selectedProducts(){},
        sort(){}
	},
    methods: {
        updateHeading(data){
            if(data && data!=''){
                data = 'Delete "' + data + '"'
                return data
            }
            else{
                return 'Delete'
            }
        },
        addGuardrail(item){
            this.actionSelectionControl = false
            this.selectedProducts = []
            this.selectedProducts.push(item)
            let path ='/AddGuardrail/product'
            this.$router.push({ path: path});
        },
        getProductList(){
            this.$store.dispatch('product/getAllProducts')
        },
        sorting(field,event){
				if((event.currentTarget.children[0].classList[2]) == 'fa-arrow-up' || (event.currentTarget.children[0].classList[2]) == 'fa-arrow-down'){
					var pastEvent = true;
				}
				for(var i=0;i<document.getElementsByClassName('sort').length;i++){
					document.getElementsByClassName('sort')[i].classList.remove('fa-arrow-up');
					document.getElementsByClassName('sort')[i].classList.remove('fa-arrow-down');
				}
				if(pastEvent){
					this.sort.order ==  'desc' ? event.currentTarget.children[0].classList.add('fa-arrow-up') :event.currentTarget.children[0].classList.add('fa-arrow-down');
					pastEvent = false;
				}
				else{
					event.currentTarget.children[0].classList.add('fa-arrow-up')
				}
				this.sort = {
					field : field,
					order : (event.currentTarget.children[0].classList[2]) == 'fa-arrow-up' ? 'asc':'desc'
				}
			},
        getDisplayDateFromTimestamp,
        openDeleteConfirmModal(item) {
            this.projectObj = item
            this.$store.state.product.deleteProdName = item.product_title
            $('#confirmSingleDeleteProduct').modal('show')
        },
		ProvideVal(){
			this.delMsg = "Can not Delete as part of Campaign"
		},
		formatDate(item){
            if(item){
                item = item.replace(/\"/g, "")
                let dateToFormat = this.convertUTCDateToLocalDate(new Date(item))
                let formated = moment(dateToFormat).format('MM/YYYY')
                return formated
            }
            else {
                return ''
            }
		},
		 convertUTCDateToLocalDate(date) {
		    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
		    var offset = date.getTimezoneOffset() / 60;
		    var hours = date.getHours();
		    newDate.setHours(hours - offset);
		    return newDate;
		},

        deleteProduct() {
            var vm =this;
            this.$store.dispatch('product/deleteProduct', { data:{ productId: this.projectObj.asin }}).then((res) => {
                    $('#confirmSingleDeleteProduct').modal('hide')
                        if(res.data == "Cannot delete"){

                                vm.notDeleted = true
                                vm.$store.dispatch('product/getAllProducts').then((res) => {
                                $('#cannotDelete').modal('show')
                                })
                        }
                        else{
                                vm.$store.state.product.deleteProdName = ''
                                vm.$store.dispatch('product/getAllProducts')
                        }
			})
        },
        navigateToAddEditProduct(item) {
            this.$store.state.product.editSelectedProduct = JSON.parse(JSON.stringify(item))
            this.$router.push({path:'/addEditProduct/' + item.id })
        },
        toggleProductSort() {
            this.productAccendingOrder = !this.productAccendingOrder
        },
        navigateToAddEditCampaign(item) {
            this.selectedProducts = []
            this.selectedProducts.push(item)
            let ids = this.selectedProducts.map((element) => {
                return element.asin
            })
            this.$router.push('addEditCampaignProduct/' + ids.join('+') );
        },
        getDataValue(item, filtertag){
            switch(filtertag.value) {
                case 'gl_product':
                    return item.gl_product
                case 'brand_product':
                    return item.brand_product
                case 'category_product':
                    return item.category_product
                case 'sub_category_product':
                    return item.sub_category_product
                case 'style_product':
                    return item.style_product
                case 'product_group_product':
                    return item.product_group_product
                case 'abbreviated_title_product':
                    return item.abbreviated_title_product
                case 'size_product':
                    return item.size_product
                case 'flavor_product':
                    return item.flavor_product
                case 'color_product':
                    return item.color_product
                case 'competitor_product':
                    return item.competitor_product
                
                default:
                    return ''
            }

        },
        navigateToAddToCampaign(item) {

            this.selectedProducts = []
            this.selectedProducts.push(item)
            let ids = this.selectedProducts.map((element) => {
                return element.asin
            })
			this.$store.state.searchFilterString = ''
            this.$router.push('addToCampaign/' + ids.join('+') + '/'+ item.go_vendor_cd + '/' + item.profile_id + '/' + btoa(item.product_title));
        },
        addProductToSelected(item) {
            if (item.isSelected) {
                this.selectedProducts.push(JSON.parse(JSON.stringify(item)))
                console.log(this.selectedProducts)
            }
            else {
                this.removeProductFromSelected(item)
            }
        },
        removeProductFromSelected(item) {
            let index = this.selectedProducts.findIndex(element => {
                return element.id == item.id
            })
            this.selectedProducts.splice(index, 1)
            console.log(this.selectedProducts);
			this.$store.state.product.actionSelectionControl = false
        },
        selectAllProduct() {
            this.productList.forEach(element => {
                element.isSelected = true
            });
            this.selectedProducts = JSON.parse(JSON.stringify(this.productList))
        },
        resetSelectAllProduct() {
            this.productList.forEach(element => {
                element.isSelected = false
            });
            this.selectedProducts = []
        },
		openDeleteTagModal(data){

			this.selectedProuctForTagToDelete = data
			$('#removeTag').modal('show')
		},
		closeRemoveTagModal(type){

			this.selectedProuctForTagToDelete = {}
			$('#removeTag').modal('hide');
			if(type!='cancel'){
				this.getProductList()
			}
		},
		addTag(item){
			this.selectedProducts = []
			this.selectedProducts.push(JSON.parse(JSON.stringify(item)))
			this.productTagsAdded = item;
            this.$store.commit("product/updateCurrentTagProduct", item)
            $("#addTagToProduct").modal('show')
		},
		closeTagModal(type){
			
			$('#addTagToProduct').modal('hide');
			this.actionSelectionControl = false;
			this.productTagsAdded = {}
            this.getProductList()
		},
		isVendorInList(item){
			if(item.go_vendor_cd){
				let data = this.$store.state.vendorList.find(e=>e.id == item.go_vendor_cd);
				if(data){
					return true
				}
				else{
					return false
				}

			}
			else{
				return false
			}
		}
    }
}
</script>

<style lang="scss">
.hightlight {
    background-color: #3da3a7 !important;
    color: #fff;
}
.link { cursor: pointer; }

</style>
